























import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    Button,
    Container,
    Dialog,
    Form,
    FormItem,
    Icon,
    Input,
    InputNumber,
    Option,
    Popconfirm,
    Select,
    Table,
    TableColumn,
    Tag,
} from "element-ui";
import { Getter } from "vuex-class";

Vue.use(Container);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Button);
Vue.use(Popconfirm);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);
Vue.use(Popconfirm);
Vue.use(Tag);

@Component({
    name: "history",
})
export default class History extends Vue {
    @Getter("history/data") data!: any;
    type = "send";

    async resetList() {
        await this.$store.dispatch("history/loadHistoryList", this.type);
    }
    mounted(): void {
        this.$store.dispatch("history/loadHistoryList", "send");
    }
}
